<template>
	<div class="pc-only">
		<div class="top-menu">
			<ul class="list">
				<li>
					<router-link to="./" class="link-over">
						<b>{{ $t("MY WALLET") }}</b>
					</router-link>
				</li>
			</ul>
			<p>{{ $t("MY ACCOUNT") }}</p>
			<ul class="list">
				<li>
					<router-link to="./account" class="link-over">
						{{ $t("ACCOUNT") }}
					</router-link>
				</li>
				<li>
					<router-link to="./referral" class="link-over">
						{{ $t("REFERRAL CODE") }}
					</router-link>
				</li>
				<li>
					<router-link to="./deposit" class="link-over">
						{{ $t("DEPOSIT (before)") }}
					</router-link>
				</li>
				<li>
					<router-link to="./deposit2" class="link-over">
						{{ $t("DEPOSIT (after)") }}
					</router-link>
				</li>
				<li>
					<router-link to="./withdraw" class="link-over">{{
						$t("WITHDRAW")
					}}</router-link>
				</li>
				<li>
					<router-link to="./plan" class="link-over">
						プラン購入
					</router-link>
				</li>
				<li>
					<router-link to="./history" class="link-over">{{
						$t("HISTORY")
					}}</router-link>
				</li>
				<li>
					<router-link to="./organization" class="link-over"
						>{{ $t("Organization") }} テーブル</router-link
					>
				</li>
				<li>
					<router-link to="./organizationchart" class="link-over"
						>{{ $t("Organization") }} チャート</router-link
					>
				</li>
				<li>
					<router-link to="./transfer" class="link-over">{{
						$t("TRANSFER")
					}}</router-link>
				</li>
			</ul>
			<p>{{ $t("INFORMATION") }}</p>
			<ul class="list">
				<li>
					<router-link to="#" class="link-over">
						{{ $t("MESSAGE") }}
					</router-link>
				</li>
				<li>
					<router-link to="#" class="link-over">
						{{ $t("FAQ") }}
					</router-link>
				</li>
				<li>
					<router-link to="#" class="link-over">
						{{ $t("CONTACT") }}
					</router-link>
				</li>
			</ul>
			<p>{{ $t("BEFORE USING") }}</p>
			<ul class="list">
				<li>
					<router-link to="#" class="link-over">
						{{ $t("PRIVACY POLICY") }}
					</router-link>
				</li>
				<li>
					<router-link to="#" class="link-over">
						{{ $t("TERMS OF USE") }}
					</router-link>
				</li>
			</ul>
			<ul class="list">
				<li>
					<router-link to="#" class="link-over">
						{{ $t("SIGN OUT") }}
					</router-link>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	name: "Sidebar",
	props: {},
};
</script>

<style scoped lang="less"></style>
